<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-rewind`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 10.003v27.994c0 1.718-2.024 2.636-3.317 1.504l-16-13.996a1.99 1.99 0 01-.683-1.48v13.972c0 1.718-2.024 2.636-3.317 1.504l-16-13.996a2 2 0 010-3.01l16-13.996C21.976 7.367 24 8.286 24 10.003v13.972a1.99 1.99 0 01.683-1.48l16-13.996C41.976 7.367 44 8.286 44 10.003zM20 14.41L9.037 24 20 33.59V14.41zm20 0L29.037 24 40 33.59V14.41z"/></svg>
</template>
<script>

export default {
  name: 'IconRewind',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
